/* istanbul ignore file */
import { useEffect, useState } from 'react';
import { useInputHelper, DefaultDropdownProps } from 'framework/form';
import { useEmployeeService, OfficeCodeDropdown } from 'domain/shared/employee';
import { snakeCase } from 'lodash';
import { InputLoader } from 'framework/ui/mui-builder';

const ExpenseOfficeDropdown = ({
  employeeSource,
  isNeedToUploadOfficeByEmployee = true,
  ...props
}: DefaultDropdownProps & { employeeSource: string; isNeedToUploadOfficeByEmployee?: boolean }) => {
  const { searchWithContractors } = useEmployeeService();
  const { getRawOnChangeCallback, getValue } = useInputHelper({ source: employeeSource });
  const rawOnChangeCallback = getRawOnChangeCallback();
  const employeeAlias = getValue();
  const [loading, setLoading] = useState(!!employeeAlias);

  useEffect(() => {
    const loadData = async () => {
      if (!employeeAlias || !isNeedToUploadOfficeByEmployee) {
        setLoading(false);
        return;
      }

      const { result } = (await searchWithContractors({
        filter: {
          alias: { in: [employeeAlias] },
        },
      })) || { result: [] };
      const office = result[0]?.office;

      if (rawOnChangeCallback) {
        rawOnChangeCallback({
          office: office ? snakeCase(office).toUpperCase() : null,
        });
      }

      setLoading(false);
    };

    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return loading ? <InputLoader /> : <OfficeCodeDropdown {...props} />;
};

export default ExpenseOfficeDropdown;
